import React, { useMemo } from 'react';
import { NavReconPositionThresholds } from '../../../../api/rs-hg/nav-recon/types';
import NavReconThresholds, {
  buildNavReconGapThresholdGroup,
  buildNavReconPositionSizeChangeThresholdGroup,
  buildNavReconPriceVariationThresholdGroup,
} from './NavReconThresholds';

interface NavReconPositionsStatsProps {
  title: string;
  fundCurrency?: string;
  threshold?: NavReconPositionThresholds;
}

const NavReconPositionsStats: React.FC<NavReconPositionsStatsProps> = ({
  title,
  fundCurrency,
  threshold,
}) => {
  const groups = useMemo(() => {
    if (!threshold) return [];

    return [
      buildNavReconGapThresholdGroup(
        threshold.p_and_l_threshold.alert,
        threshold.p_and_l_threshold.fail,
        { id: 'p-and-l', label: 'P/L Gap' },
      ),
      buildNavReconPriceVariationThresholdGroup(
        threshold.price_variation_threshold.lower_threshold,
        threshold.price_variation_threshold.upper_threshold,
        { id: 'price-variation', label: 'Price Variation' },
      ),
      buildNavReconPositionSizeChangeThresholdGroup(
        threshold.position_size_change_threshold,
        { id: 'position-size-change', label: 'Position Size Change' },
      ),
      buildNavReconPositionSizeChangeThresholdGroup(
        threshold.position_price_change_threshold,
        { id: 'position-price-change', label: 'Position Price Change' },
      ),
    ].filter((group): group is NonNullable<typeof group> => group != null);
  }, [threshold]);

  return (
    <div className="flex w-full flex-wrap items-center gap-x-4 gap-y-2">
      <h2 className="whitespace-nowrap text-base font-semibold text-mainblue">
        {title}
      </h2>

      <div className="flex flex-wrap items-center gap-3 text-xs">
        {fundCurrency ? (
          <div className="flex items-center space-x-2 rounded-lg border border-blue-100 bg-blue-50/40 px-3 py-1 text-sm leading-none shadow-sm">
            <span className="h-2 w-2 rounded-full bg-mainblue" />
            <span className="font-medium text-mainblue">Fund Currency:</span>
            <span className="font-bold text-mainblue">{fundCurrency}</span>
          </div>
        ) : null}

        <NavReconThresholds groups={groups} />
      </div>
    </div>
  );
};

export default NavReconPositionsStats;
